<template>
	<div>
		<el-form v-if="formData" ref="formData" :model="formData" label-position="top" class="MT20">
			<el-row :gutter="20" class="MT10">
				<el-col :span="12">
					<el-form-item prop="playPriceTicketFormat" label="实际打款金额(￥):" :rules="paymentAmountRules">
						<el-input-number v-model="formData.playPriceTicketFormat" style="width:100%" :precision="2"
							controls-position="right" :min="0.00" :max="99999999.99" size="medium"
							placeholder="请填写打款金额" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item prop="playPriceNo" label="打款流水号:" :rules="paymentNoRules">
						<el-input v-model="formData.playPriceNo" maxlength="50" size="medium" placeholder="请填写打款流水号" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item prop="inconsistentDesc" label="金额不一致的原因:(仅后台记录):">
				<el-input v-model="formData.inconsistentDesc" type="textarea" :rows="2" maxlength="100" show-word-limit
					placeholder="请填写金额不一致的原因:(仅后台记录):" />
			</el-form-item>
			<el-form-item prop="playPic">
				<span slot="label">
					打款截图: <small>支持格式为JPG、PNG,不大于10M,最多上传3张</small>
				</span>
				<div>
					<el-upload action list-type="picture-card" accept="image/png,image/jpeg"
						:file-list="formData.fileList" :http-request="handleUpload" :on-remove="handleRemove"
						:before-upload="handleBeforeUpload" :disabled="uploadLoading" :limit="3"
						:on-exceed="handleExceed" :key="uploadKey">
						<el-progress v-if="uploadProgress && uploadProgress < 100" :width="120" type="circle"
							:percentage="uploadProgress" />
						<i v-else class="el-icon-plus" />
					</el-upload>
				</div>
			</el-form-item>
			<el-form-item prop="playDesc" label="打款备注:">
				<el-input v-model="formData.playDesc" type="textarea" :rows="2" maxlength="100" show-word-limit
					placeholder="请填写打款备注" />
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		uploadImg
	} from '@/assets/js/commonApi.js';

	var DEFAULT_FORM_DATA = {
		playDesc: '',
		playPriceNo: '',
		playPic: [],
		playPriceTicketFormat: '',
		inconsistentDesc: ''
	};

	export default {
		name: 'SettlementEdit',
		props: {
			data: {
				type: Object,
				default: null
			},
			audiId: {
				type: [Number, String],
				default: null
			},
			btnLoading: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				uploadLoading: false,
				uploadProgress: null,
				uploadKey: Date.now(), // 添加 uploadKey 用于强制重新渲染上传组件
				formData: this.getInitialFormData()
			};
		},
		watch: {
			// 监听 data 变化，当父组件传入新的 data 时更新表单
			'data': {
				handler: function(newVal) {
					if (newVal) {
						this.initFormData();
					}
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			// 金额校验规则
			paymentAmountRules: function() {
				return [{
					required: true,
					message: '请填写实际打款金额'
				}];
			},
			// 流水号校验规则
			paymentNoRules: function() {
				return [{
					required: true,
					message: '请填写打款流水号'
				}];
			},
			// 预计结款金额（去除千分位逗号）
			expectedAmount: function() {
				if (!this.data || !this.data.referenceInfo || !this.data.referenceInfo.expectedTotalAmount) {
					return null;
				}
				return parseFloat(this.data.referenceInfo.expectedTotalAmount.replace(/,/g, ''));
			},
			// 实际打款金额
			actualAmount: function() {
				return parseFloat(this.formData.playPriceTicketFormat);
			}
		},
		methods: {
			// 获取初始表单数据
			getInitialFormData: function() {
				var fileList = [];
				var playPic = [];

				if (this.data) {
					if (this.data.fileList) {
						// 深拷贝 fileList
						fileList = this.data.fileList.map(function(item) {
							return {
								url: item.url
							};
						});
					}
					if (this.data.playPic) {
						// 深拷贝 playPic
						playPic = this.data.playPic.slice();
					}
				}

				return {
					...DEFAULT_FORM_DATA,
					playPic: playPic,
					fileList: fileList
				};
			},

			// 初始化表单数据
			initFormData: function() {
				var fileList = [];
				var playPic = [];

				if (this.data) {
					if (this.data.fileList) {
						fileList = this.data.fileList.map(function(item) {
							return {
								url: item.url
							};
						});
					}
					if (this.data.playPic) {
						playPic = this.data.playPic.slice();
					}
				}

				this.formData = {
					...DEFAULT_FORM_DATA,
					playPic: playPic,
					fileList: fileList
				};

				// 更新 upload 组件的 key，强制重新渲染
				this.uploadKey = Date.now();
			},

			// 重置表单
			resetForm: function() {
				if (this.$refs.formData) {
					this.$refs.formData.resetFields();
				}

				// 清空所有数据
				this.formData = {
					...DEFAULT_FORM_DATA,
					playPic: [],
					fileList: []
				};

				// 强制重新渲染上传组件
				this.uploadKey = Date.now();
			},

			// 处理文件超出限制
			handleExceed: function() {
				this.$message.warning('最多上传3张图片');
			},

			// 处理文件移除
			handleRemove: function(file, fileList) {
				var self = this;

				// 使用 url 来识别要删除的文件
				var fileUrl = file.url || file.response?.url;

				// 从 playPic 中移除对应的 URL
				var newPlayPic = [];
				for (var i = 0; i < self.formData.playPic.length; i++) {
					// 如果当前图片的 URL 不等于要删除的文件的 URL，则保留
					if (self.formData.playPic[i] != fileUrl) {
						newPlayPic.push(self.formData.playPic[i]);
					}
				}
				self.formData.playPic = newPlayPic;

				// 更新 fileList
				self.formData.fileList = fileList.map(function(item) {
					return {
						url: item.url || item.response?.url
					};
				});
			},

			// 上传前处理
			handleBeforeUpload: function(file) {				
				return true;
			},

			// 验证金额一致性
			validateAmountConsistency: function() {
				if (!this.expectedAmount || isNaN(this.actualAmount)) {
					return true;
				}

				var isAmountDifferent = this.actualAmount != this.expectedAmount;
				var isReasonEmpty = !this.formData.inconsistentDesc ||
					!this.formData.inconsistentDesc.trim();

				if (isAmountDifferent && isReasonEmpty) {
					this.$message.error('请填写金额不一致的原因:(仅后台记录)');
					return false;
				}
				return true;
			},

			// 处理图片上传
			handleUpload: function(req) {
				var self = this;
				var file = req.file;

				// 验证文件格式
				if (!self.validateFileFormat(file)) return;

				// 验证文件大小
				if (!self.validateFileSize(file)) return;

				// 上传图片
				self.uploadLoading = true;

				var formData = new FormData();
				formData.append('file', file);

				uploadImg(formData, function(ev) {
					self.uploadProgress = Math.floor((ev.loaded / ev.total) * 100);
				}).then(function(res) {
					var data = res.data;
					if (data.state == 1) {
						// 创建新的数组，确保响应式更新
						var newFileList = self.formData.fileList.concat([{
							url: data.result.urlFull
						}]);
						var newPlayPic = self.formData.playPic.concat([data.result.url]);

						self.formData.fileList = newFileList;
						self.formData.playPic = newPlayPic;
					} else {
						self.$message.error(data.msg || '上传失败');
					}
				}).catch(function() {
					self.$message.error('上传失败，请重试');
				}).finally(function() {
					self.uploadLoading = false;
					self.uploadProgress = null;
				});
			},

			// 验证文件格式
			validateFileFormat: function(file) {
				var isValid = file.type == 'image/jpeg' || file.type == 'image/png';
				if (!isValid) {
					this.$message.error('图片格式错误，请重新上传');
				}
				return isValid;
			},

			// 验证文件大小
			validateFileSize: function(file) {
				var isValid = file.size / 1024 / 1024 < 10;
				if (!isValid) {
					this.$message.error('图片尺寸错误，请重新上传');
				}
				return isValid;
			},

			// 提交表单
			onSubmit: function(callback) {
				var self = this;

				// 验证金额一致性
				if (!self.validateAmountConsistency()) return;

				if (!self.$refs.formData) {
					if (callback) callback();
					return;
				}

				self.$refs.formData.validate(function(valid) {
					if (!valid) return;

					self.$confirm('确定提交结款信息？', '提示', {
						type: 'warning',
						center: true,
						closeOnClickModal: false
					}).then(function() {
						self.submitForm(callback);
					}).catch(function() {});
				});
			},

			// 提交表单数据
			submitForm: function(callback) {
				var self = this;
				self.$emit('update:btnLoading', true);

				var requestData = {
					playDesc: self.formData.playDesc,
					playPriceNo: self.formData.playPriceNo,
					playPic: self.formData.playPic,
					playPriceTicketFormat: self.formData.playPriceTicketFormat,
					inconsistentDesc: self.formData.inconsistentDesc,
					audiId: self.audiId,
					id: self.data.id
				};

				self.$request({
					url: '/activityFinanceSettle/receivables',
					data: requestData,
					method: 'post'
				}).then(function(res) {
					var data = res.data;
					if (data.state == 1) {
						self.$message.success('操作成功');
						// 完全重置表单
						self.resetForm();
						// 触发成功事件
						if (callback) callback();
						self.$emit('submit-success');
					} else {
						self.$message.error(data.msg || '操作失败，请重试');
					}
				}).catch(function() {
					self.$message.error('操作失败，请重试');
				}).finally(function() {
					self.$emit('update:btnLoading', false);
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.info-table {
		.el-image {
			width: 60px;
			height: 60px;
			margin-right: 5px;
		}
	}
</style>